import { NavLink } from 'react-router-dom';
import type { CategorySummary } from '@/types/news';
import { cn } from '@/utils/cn';

type CategoryRailProps = {
  categories: CategorySummary[];
};

export function CategoryRail({ categories }: CategoryRailProps) {
  return (
    <div className="safe-px sticky top-[6.25rem] z-20 bg-black/82 py-3 backdrop-blur-xl">
      <div className="mx-auto flex max-w-app gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <NavLink
          to="/"
          className={({ isActive }) =>
            cn(
              'shrink-0 rounded border border-white/10 px-3 py-2 text-sm font-semibold text-white/68 transition',
              isActive && 'border-divergent-yellow bg-divergent-yellow text-black'
            )
          }
        >
          Todo
        </NavLink>
        {categories.map((category) => (
          <NavLink
            key={category.slug}
            to={`/categoria/${category.slug}`}
            className={({ isActive }) =>
              cn(
                'shrink-0 rounded border border-white/10 px-3 py-2 text-sm font-semibold text-white/68 transition',
                isActive && 'border-divergent-yellow bg-divergent-yellow text-black'
              )
            }
          >
            {category.name}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
